import styled from '@benzinga/themetron';
import React, { FunctionComponent, ReactNode } from 'react';
import { DivComponent, toPercentageString } from './utils';

export interface FillContainerProps {
  children?: ReactNode;
  className?: string;
  end: number;
  start: number;
}

const FillContainer = styled(DivComponent).attrs<
  FillContainerProps & {
    left?: string;
    width?: string;
  }
>(props => {
  const left = toPercentageString(props.start);
  const width = toPercentageString(props.end - props.start);
  if (left instanceof Error) {
    console.error(left);
  } else if (width instanceof Error) {
    console.error(width);
  } else {
    return {
      left,
      width,
    };
  }
  return {
    left: '0',
    width: '0',
  };
})<FillContainerProps>`
  bottom: 0;
  left: ${props => props.left};
  position: absolute;
  top: 0;
  width: ${props => props.width};
`;

interface FillPositionerProps {
  children: ReactNode;
  className?: string;
}

// this allows anything inside the fill to be positioned relative to the fill.
const FillPositioner: FunctionComponent<FillPositionerProps> = styled(DivComponent)`
  height: 100%;
  position: relative;
  width: 100%;
`;

export interface FillProps {
  children: ReactNode;
  className?: string;
  end: number;
  start: number;
}

const Fill = ({ children, className, end, start }: FillProps) => (
  <FillContainer className={className} end={end} start={start}>
    <FillPositioner>{children}</FillPositioner>
  </FillContainer>
);

export default Fill;
